import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Label, { DisplayLabel } from "../ui/Label";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import POSList from "../components/POSList";
import Input from "../ui/Input";
import Float from "../ui/Float";
import POSDetails from "../components/POSDetails";
import Nav from "../ui/Nav";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import POSItems from "../components/POSItems";

export default function POSController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const [view, setView] = useState(true);
    const [edit, setEdit] = useState(false);

    const pos_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Cpy" },
        { key: KBD.V, text: "View", action: () => setView(!view) },
        { text: "Del" },
        { text: "Edt" },
        { text: "@Edt" },
        { text: "GftRct" },
    ]

    useEffect(() => {
        window.bm_state.value = ROUTES.POS.POS;
        const cleanup = listen(controller, ROUTES.POS.POS, pos_nav);
        return cleanup;
    }, [pos_nav])




    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", gap: "15px" }}>


                <POSDetails controller={controller} setSelectedItem={setSelectedItem} setSelected={setSelected} items={items} setItems={setItems} selected={selected} />
                <div className="shim" />

                <POSList
                    controller={controller}
                    loading={loading}
                    setLoading={setLoading}
                    route={ROUTES.POS.POS}
                    data={data}
                    setData={setData}
                    selected={selected}
                    setSelected={setSelected}
                    signal={signal}
                    align={align}
                    setAlign={setAlign}
                    view={view}
                />

                <POSItems
                    controller={controller}
                    view={view}
                    loading={loading}
                    setLoading={setLoading}
                    route={ROUTES.POS.EDIT}
                    data={items}
                    setData={setItems}
                    selected={selectedItem}
                    setSelected={setSelectedItem}
                    signal={signal}
                />


                <div className="shim" />
                <Divider />
                <div style={{ 'height': "30px" }}>

                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={pos_nav} />
                    </Space>

                </div>
            </div>
        </div>
    )
}